import DetailsPageBanner from '@Components/DetailsPageBanner/DetailsPageBanner';
import { SubscriptionUpdates } from '@Components/SubscriptionUpdates/SubscriptionUpdates';
import { APIResponse, APIStatus } from '@Src/services/baseInterfaces';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HomeLayout from '../layout/components/HomeLayout/HomeLayout';
import { getBoardsFilterList, getSubjectTestList } from './services/ClassesDetails.service';
import { FilterIndex } from '../Filter/Filter';
import SubjectTests from './Components/SubjectTests/SubjectTests';
import { Filters } from './Components/Filters/Filters';
import { FILTER_KEYS, FILTER_LIST } from '../Filter/Constants/filters.constants';
import { HeaderNameKeys } from '@Constants/app.constant';
import { useAppSelector } from '@App/hooks';
import { getLanguageList } from '../UserProfile/Services/UserProfile.sevice';

const ClassesDetailsIndex = () => {
    const params = useParams();
    const classId = params.classId;
    let className = params.className;
    let Headings = [
        { name: className, type: HeaderNameKeys.CLASS, id: classId }
    ]
    const [subjectList, setSubjectList] = useState<Array<any>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<any>([]);
    const [board, setBoard] = useState<any>({});
    const [headingsBreadcrumb, setHeadingsBreadcrumb] = useState<Array<any>>(Headings);
    const [initialFilters, setInitialFilters] = useState<Array<any>>([]);
    const loginData = useAppSelector((state: any) => state.login);

    useEffect(() => {
        window.scrollTo(0, 0);
        getAllBoardsFilterList();
        
        let param: any = {};
        let initialFilters: any = [{ [FILTER_KEYS.CLASS]: { Id: Number(classId), Name: className } }];
        
        if (loginData?.isLoggedIn && loginData?.LanguageId) {
            param[FILTER_KEYS.LANGUAGE] = [loginData.LanguageId];
            const langName = loginData.LanguageName || 'Language';
            initialFilters.push({ [FILTER_KEYS.LANGUAGE]: { Id: loginData.LanguageId, Name: langName } });
        }
        
        setInitialFilters(initialFilters);
        getAllSubjectList(param);
    }, [classId, loginData]);
    
    useEffect(() => {
        getLanguageList().then((response: any) => {
            if (response?.ResponseType === 'SUCCESS') {
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.LANGUAGE]: response.data || []
                }));
            }
        });
    }, []);

    function getAllSubjectList(filterParam?: any) {
        setIsLoading(true)
        let param: any = {
            classId: classId
        }
        if (filterParam) {
            Object.assign(param, filterParam);
        }
        if (loginData?.isLoggedIn && loginData?.LanguageId && !param.languageId) {
            param.languageId = [loginData.LanguageId];
        }
        getSubjectTestList(param).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                let data = response?.data;
                setSubjectList(data);
                setIsLoading(false)
            }
        })
    }

    function getAllBoardsFilterList() {
        setFilters([]);
        let params = {
            classId: classId
        }
        getBoardsFilterList(params).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                // let data = response?.data;
                let filtersData = {
                    [FILTER_LIST.BOARD]: response?.data
                }
                setFilters(filtersData);
            }
        })
    }

    const submitFilters = (filters: any) => {
        let newFilters: any = filters;
        setBoard(newFilters[FILTER_KEYS.BOARD]);
        let params = modifiedFilters(newFilters);
        if (loginData?.isLoggedIn && loginData?.LanguageId && !params.languageId) {
            params.languageId = [loginData.LanguageId];
        }
        getAllSubjectList(params)
    }

    // Add standardized filter callbacks
    submitFilters.updateSubjects = (subjectData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.SUBJECT]: subjectData
        }));
    };

    submitFilters.updateChapters = (chapterData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CHAPTER]: chapterData
        }));
    };

    submitFilters.updateTopics = (topicData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.TOPIC]: topicData
        }));
    };

    submitFilters.updateDifficultyLevels = (difficultyData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.DIFFICULTY]: difficultyData
        }));
    };

    // Fetch difficulty levels on mount
    useEffect(() => {
        import('../TestDetails/services/TestDetails.service').then(({ getDifficultyLevels }) => {
            getDifficultyLevels().then((response: any) => {
                if (response?.ResponseType === 'SUCCESS') {
                    setFilters((prev: any) => ({
                        ...prev,
                        [FILTER_LIST.DIFFICULTY]: response.data || []
                    }));
                }
            });
        });
    }, []);

    const modifiedFilters = (filters: any) => {
        let payload: any = {};
        let keys = Object.keys(filters);
        keys.forEach((key) => {
            if (key === 'keyword' && filters[key]) {
                payload[key] = filters[key];
            } else if (filters[key] && typeof (filters[key]) == 'object') {
                if (Array.isArray(filters[key])) {
                    if (filters[key].length > 0) {
                        const ids = filters[key].map((filter: any) => filter.Id);
                        if (key === FILTER_KEYS.SUBJECT) {
                            payload.subjectId = ids.join(',');
                        } else {
                            payload[key] = ids;
                        }
                    }
                } else {
                    if (filters[key].Id !== undefined && filters[key].Id !== null) {
                        if (key === FILTER_KEYS.DIFFICULTY || key === FILTER_KEYS.CHAPTER || key === FILTER_KEYS.TOPIC || key === FILTER_KEYS.LANGUAGE) {
                            payload[key] = [filters[key].Id];
                        } else if (key === FILTER_KEYS.SUBJECT) {
                            payload.subjectId = filters[key].Id.toString();
                        } else {
                            payload[key] = filters[key].Id;
                        }
                    }
                }
            }
        });
        return payload
    }

    return (
        <>
            <HomeLayout >
                {/* <!-----------------------------------test-listining-section-------------------------------> */}
                <div className="test-listining">
                    <DetailsPageBanner Headings={headingsBreadcrumb} />
                    <FilterIndex
                        filters={filters}
                        submitFilters={submitFilters}
                        initialFilters={initialFilters}
                    />
                    <SubjectTests subjectList={subjectList} classId={classId} name={params.className} board={board} />
                    <SubscriptionUpdates />
                </div>

                {/* <!----------------------------------end-test-listining-section------------------------------->  */}
            </HomeLayout>

        </>
    );
}

export default ClassesDetailsIndex;
